module.exports = __webpack_public_path__ + "img/17.afd1fe79.png";